import React from "react";
import { useAuth } from "../../auth/useAuth";
import Alert, { AlertMessage, AlertTitle } from "../../components/Alert";
import Loader from "../../components/Loader";
import { useSpaceInfo } from "../../roomservice/maps";
import LogInButton from "../LogInButton";

// Verifies if user has creation permissions if they're accessing a space that doesn't have an owner
// In the future, we'll want to have a proper way to create spaces with permissions
// For now, we'll rely on a RoomService map inside a space to see if it has an owner
// If it does, anonymous access is OK
// If it doesn't, user needs to be authenticated, after which they'll become owner of the space
export default function SpaceCreationLoader({
  children,
}: React.PropsWithChildren<{}>) {
  const [spaceInfo, spaceInfoClient] = useSpaceInfo();
  const hasOwner = spaceInfo?.owners && spaceInfo.owners.length > 0;
  const { auth } = useAuth();

  if (!spaceInfo) return <Loader>Loading...</Loader>;

  if (!hasOwner && auth) spaceInfoClient?.set("owners", [auth.issuer]);

  if (hasOwner) return <> {children} </>;

  return (
    <Alert>
      <AlertTitle>Cannot create space</AlertTitle>
      <AlertMessage>
        You can only create a space if you have a MakeSpace account and logged
        in with your email.
      </AlertMessage>
      <LogInButton redirect={window.location.pathname} />
    </Alert>
  );
}
